import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withStyles, makeStyles, createStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import {
  Tooltip,
  Checkbox, Drawer, Box,  Typography, Button
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { IconButton, Chip } from "@material-ui/core";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import Paper from "@material-ui/core/Paper";
import Pagination from "@material-ui/lab/Pagination";
import HelpIcon from "@material-ui/icons/Help";
import MapIcon from '@material-ui/icons/Map';
import {
  setPeriodType,
  setCurrentPageNumber,
  setSelectedTag,
  setSavedSelectedTagData,
} from "../../actions";
import _ from "lodash";
import TagConfig from "../../config/TagConfig";

const useStyles = makeStyles((theme) =>
  createStyles({
    tableWrapper: {
      width: "100%",
    },
    tableWrapperSlim: {
      width: "89%",
    },
    table: {
      width: "100%",
    },
    tableHead: {
      height: 40,
      backgroundColor: "#fafafa",
    },
    tableRow: {
      height: 126,
      "&:hover": {
        backgroundColor: theme.palette.action.hover, // Use a light grey color on hover
      },
    },
    tableRowNone: {
      height: 126,
    },
    noDataCell: {
      textAlign: "center",
      padding: theme.spacing(3),
      fontSize: 14,
      color: theme.palette.text.secondary,
    },
    thumb: {
      width: 80,
    },
    thumbWrapper: {
      position: "relative",
      width: 90,
      height: 90,
    },
    thumbSkeleton: {
      position: "absolute",
      inset: 0,
      borderRadius: 6,
      background:
        "linear-gradient(90deg, #f2f2f2 25%, #e6e6e6 37%, #f2f2f2 63%)",
      backgroundSize: "400% 100%",
      animation: "$skeletonShimmer 1.2s ease-in-out infinite",
    },
    "@keyframes skeletonShimmer": {
      "0%": { backgroundPosition: "100% 0" },
      "100%": { backgroundPosition: "0 0" },
    },
    pagination: {
      display: "flex",
      justifyContent: "center",
      marginTop: theme.spacing(4),
      marginBottom: theme.spacing(4),
    },
    imagePopup: {
      position: "fixed", // Change to fixed so it stays within the viewport
      border: "1px solid #ccc",
      backgroundColor: "#fff",
      padding: theme.spacing(1),
      boxShadow: theme.shadows[3],
      zIndex: 1000,
    },
    tagUnSelect: {
      marginTop: theme.spacing(-2.6),
      fontSize: 9,
      "& .MuiInputLabel-root": {
        fontSize: "14px", // Smaller font size for the label (placeholder)
      },
      "& .MuiInputBase-input": {
        fontSize: "14px", // Customize input text size (if needed)
      },
    },
    tagSelect: {
      minWidth: 300,
      maxWidth: 300,
      marginTop: theme.spacing(-2.6),
      "& .MuiInputLabel-root": {
        fontSize: "14px", // Smaller font size for the label (placeholder)
      },
      "& .MuiInputBase-input": {
        fontSize: "14px", // Customize input text size (if needed)
      },
    },
    iconTooltip: {
      fontSize: 18,
      marginTop: -4,
      marginLeft: 4,
    },
    tagWrapper: {
      display: "flex",
    },
    saveButton: {
      fontWeight: "medium",
      height: 30,
      marginTop: -4,
      marginLeft: 16,
      paddingTop: 8,
    },
    tooltip: {
      fontSize: "12px", // フォントサイズを小さく
      paddingTop: "8px", // Tooltip の余白調整
    },
    icon: {
      paddingTop: "4px", // アイコンの位置調整
    },
  })
);

const PhotoTable = ({
  setRange,
  dateRange,
  periodType,
  setPeriodType,
  homeImageData,
  homeImageDataNtt,
  homeImageDataHokuden,
  homeMissionImageData,
  totalAssetStats,
  setCurrentPageNumber,
  filteredTotal,
  setSelectedTag,
  setSavedSelectedTagData,
  selectedTag,
  handleDrawerOpen,
  handleDrawerClose,
  handleImageSelect,
  tagSavingLoader,
  open,
  downloadImage,
  setDownloadImage,
  filterType,
  reportData,
  reportDataNtt,
  activeDownload,
  currentPageNumber,
  companyName,
  selectedSeasonLabel,
  selectedMissionLabel,
  pageTopLoader,
  missionOnly,
}) => {
  const classes = useStyles();
  const [tableData, setTableData] = useState([]);
  const [tagData, setTagData] = useState([]);
  const [totalAssets, setTotalAssets] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [hoveredImage, setHoveredImage] = useState(null);
  const [hoverPosition, setHoverPosition] = useState({ x: 0, y: 0 });
  const [mapDrawerOpen, setMapDrawerOpen] = useState(false);
  const [selectedLatLng, setSelectedLatLng] = useState({ lat: null, lng: null });
  const [missionUrlParam, setMissionUrlParam] = useState(false);
  const [loadedImages, setLoadedImages] = useState({});
  const [loadCycle, setLoadCycle] = useState(0);
  const itemsPerPage = 10;
  const popupWidth = 300;
  const popupHeight = 300;
  const columnWidth = companyName !== "ntt" ? "7%" : "10%";

  useEffect(() => {
    if (typeof filteredTotal === "number") {
      setTotalAssets(filteredTotal);
    }
  }, [filteredTotal]);

  useEffect(() => {
    if (periodType === "season") {
      setTagData(TagConfig.seasonTag);
      setMissionUrlParam(false);
    } else {
      setTagData(TagConfig.missionTagB.concat(TagConfig.missionTagC));
      if (selectedMissionLabel !== "") {
        setMissionUrlParam(true);
      } else {
        setMissionUrlParam(false);
      }
    }
  }, [periodType]);

  useEffect(() => {
    const dataForTable = filterType === "photo" ? homeImageData : reportData;
    if (dataForTable.length > 0) {
      let imageDataObj = {},
        imageArray = [];
      _.each(dataForTable, function (data) {
        imageDataObj.signNumber = data.signNumber;
        imageDataObj.signName = data.signName;
        imageDataObj.name = data.name;
        imageDataObj.placeCode = data.placeCode;
        imageDataObj.assetNum = data.assetNum;
        imageDataObj.fileName = data.fileName;
        imageDataObj.tag = data.tag;
        imageDataObj.user = data.user;
        imageDataObj.fileUrl = data.fileUrl;
        const dateObj = new Date(data.occurred_datetime);
        imageDataObj.dateTime = dateObj
          .toISOString()
          .slice(0, 19)
          .replace("T", " ");
        imageDataObj.latitude = data.latitude;
        imageDataObj.longitude = data.longitude;
        imageArray.push(imageDataObj);
        imageDataObj = {};
      });
      if (periodType === "mission") {
        setMissionUrlParam(true);
      }
      setLoadedImages({});
      setTableData(imageArray);
    } else {
      setTableData([]);
      setTotalAssets(0);
      setLoadedImages({});
      if (periodType === "mission") {
        setMissionUrlParam(false);
      }
    }
  }, [homeImageData, reportData, filterType]);

  useEffect(() => {
    if (!missionOnly || periodType !== "mission") {
      return;
    }
    const dataForTable =
      filterType === "photo" ? homeMissionImageData : reportData;
    if (dataForTable.length > 0) {
      let imageDataObj = {},
        imageArray = [];
      _.each(dataForTable, function (data) {
        imageDataObj.venueName = data.venueName;
        imageDataObj.fileName = data.fileName;
        imageDataObj.tag = data.tag || [];
        imageDataObj.user = data.user;
        imageDataObj.fileUrl = data.fileUrl;
        const dateObj = new Date(data.occurred_datetime);
        imageDataObj.dateTime = dateObj
          .toISOString()
          .slice(0, 19)
          .replace("T", " ");
        imageDataObj.latitude = data.latitude;
        imageDataObj.longitude = data.longitude;
        imageArray.push(imageDataObj);
        imageDataObj = {};
      });
      setLoadedImages({});
      setTableData(imageArray);
    } else {
      setTableData([]);
      setTotalAssets(0);
      setLoadedImages({});
    }
  }, [missionOnly, periodType, homeMissionImageData, reportData, filterType]);

  useEffect(() => {
    const dataForTable =
      filterType === "photo" ? homeImageDataNtt : reportDataNtt;
    if (dataForTable.length > 0) {
      let imageDataObj = {},
        imageArray = [];
      _.each(dataForTable, function (data) {
        imageDataObj.signNumber = data.signNumber;
        imageDataObj.signName = data.signName;
        imageDataObj.name = data.name;
        imageDataObj.placeCode = data.placeCode;
        imageDataObj.assetNum = data.assetNum;
        imageDataObj.fileName = data.fileName;
        imageDataObj.tag = data.tag;
        imageDataObj.user = data.user;
        imageDataObj.fileUrl = data.fileUrl;
        const dateObj = new Date(data.occurred_datetime);
        imageDataObj.dateTime = dateObj
          .toISOString()
          .slice(0, 19)
          .replace("T", " ");
        imageDataObj.latitude = data.latitude;
        imageDataObj.longitude = data.longitude;
        imageArray.push(imageDataObj);
        imageDataObj = {};
      });
      setLoadedImages({});
      setTableData(imageArray);
    } else {
      setTableData([]);
      setTotalAssets(0);
      setLoadedImages({});
    }
  }, [homeImageDataNtt, reportDataNtt, filterType]);

  useEffect(() => {
    const dataForTable =
      filterType === "photo" ? homeImageDataHokuden : reportDataNtt;
    if (dataForTable.length > 0) {
      let imageDataObj = {},
        imageArray = [];
      _.each(dataForTable, function (data) {
        imageDataObj.signNumber = data.signNumber;
        imageDataObj.signName = data.signName;
        imageDataObj.name = data.name;
        imageDataObj.placeCode = data.placeCode;
        imageDataObj.fileName = data.fileName;
        imageDataObj.tag = data.tag;
        imageDataObj.user = data.user;
        imageDataObj.fileUrl = data.fileUrl;
        const dateObj = new Date(data.occurred_datetime);
        imageDataObj.dateTime = dateObj
          .toISOString()
          .slice(0, 19)
          .replace("T", " ");
        imageDataObj.latitude = data.latitude;
        imageDataObj.longitude = data.longitude;
        imageArray.push(imageDataObj);
        imageDataObj = {};
      });
      setLoadedImages({});
      setTableData(imageArray);
    } else {
      setTableData([]);
      setTotalAssets(0);
      setLoadedImages({});
    }
  }, [homeImageDataHokuden]);

  useEffect(() => {
    setCurrentPage(currentPageNumber);
  }, [currentPageNumber]);

  useEffect(() => {
    if (pageTopLoader) {
      setLoadedImages({});
      setLoadCycle((prev) => prev + 1);
    }
  }, [pageTopLoader]);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
    setCurrentPageNumber(value);
  };

  const getViewUrlView = (photoId) => {
    const missionLabelParam = selectedMissionLabel && periodType == "mission"
      ? `?mission=${encodeURIComponent(selectedMissionLabel)}` : '';
    return `/viewer/${encodeURIComponent(photoId)}${missionLabelParam}`;
  };

  const pageCount = Math.ceil(totalAssets / itemsPerPage);

  const handleMouseEnter = (imageUrl, e) => {
    setHoveredImage(imageUrl);
    setHoverPosition({ x: e.clientX, y: e.clientY });
  };

  const handleMouseMove = (e) => {
    setHoverPosition({ x: e.clientX, y: e.clientY });
  };

  const handleMouseLeave = () => {
    setHoveredImage(null);
  };

  const handleImageLoad = (fileUrl) => {
    if (!fileUrl) return;
    setLoadedImages((prev) =>
      prev[fileUrl] ? prev : { ...prev, [fileUrl]: true }
    );
  };

  const handleImageError = (fileUrl) => {
    if (!fileUrl) return;
    setLoadedImages((prev) => ({ ...prev, [fileUrl]: true }));
  };

  const getImageRef = (fileUrl) => (node) => {
    if (node && node.complete) {
      handleImageLoad(fileUrl);
    }
  };

  const calculatePopupTop = (y) => {
    const viewportHeight = window.innerHeight;
    const top = y - popupHeight / 2;
    if (top < 0) return 0;
    if (top + popupHeight > viewportHeight) return viewportHeight - popupHeight;
    return top;
  };

  const calculatePopupLeft = (x) => {
    const viewportWidth = window.innerWidth;
    const left = x + 20;
    if (left + popupWidth > viewportWidth) return viewportWidth - popupWidth;
    return left;
  };

  const handleOpenMap = (lat, lng) => {
    setSelectedLatLng({ lat, lng });
    setMapDrawerOpen(true);
  };

  const handleCloseMap = () => {
    setMapDrawerOpen(false);
  };

  return (
    <>
      <Grid
        container
        direction="column"
        justifyContent={"center"}
        className={open ? classes.tableWrapperSlim : classes.tableWrapper}
      >
        <Grid item className={classes.filterItem}>
          <TableContainer component={Paper} className={classes.tableContainer}>
            <Table stickyHeader className={classes.table}>
              <TableHead className={classes.tableHead}>
                <TableRow className={classes.stickyHeader}>
                  {activeDownload && (
                    <TableCell align="center">
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Checkbox
                          checked={
                            downloadImage.length > 0 &&
                            downloadImage.length === tableData.length
                          } // 全選択判定
                          indeterminate={
                            downloadImage.length > 0 &&
                            downloadImage.length < tableData.length
                          } // 部分選択時
                          onChange={(e) => {
                            if (e.target.checked) {
                              // 全選択
                              setDownloadImage(
                                tableData.map((row) => row.fileUrl)
                              );
                            } else {
                              // リセット
                              setDownloadImage([]);
                            }
                          }}
                          inputProps={{ "aria-label": "select all" }}
                        />

                        <Tooltip
                          title={
                            <div>
                              一括ダウンロード選択
                              <br />
                              <small>※最大10件まで選択可能です</small>
                            </div>
                          }
                          placement="top"
                          classes={{ tooltip: classes.tooltip }}
                        >
                          <HelpIcon fontSize="small" className={classes.icon} />
                        </Tooltip>
                      </div>
                    </TableCell>
                  )}
                  <TableCell className={classes.thumb}></TableCell>
                  {(companyName === "tepco") && (
                    <>
                      <TableCell align="center">標識番号</TableCell>
                      <TableCell align="center">標識名</TableCell>
                      <TableCell align="center">設備番号</TableCell>
                      <TableCell align="center">スキーマ番号</TableCell>
                    </>
                  )}
                  {companyName === "mitsubishi" && (
                    <>
                      <TableCell align="center">識別情報</TableCell>
                    </>
                  )}
                  {companyName === "ntt" && (
                    <>
                      <TableCell align="center">県域</TableCell>
                      <TableCell align="center">収容局名</TableCell>
                      <TableCell align="center">電柱情報</TableCell>
                      <TableCell align="center">撮影対象</TableCell>
                    </>
                  )}
                  {companyName === "ntt-ft" && (
                    <>
                      <TableCell align="center">県域</TableCell>
                      <TableCell align="center">収容局名</TableCell>
                      <TableCell align="center">電柱識別番号</TableCell>
                      <TableCell align="center">撮影対象</TableCell>
                    </>
                  )}
                  {companyName === "hokuden" && (
                    <>
                      <TableCell align="center">電柱番号</TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center">市町村名</TableCell>
                      <TableCell align="center">支店コード</TableCell>
                    </>
                  )}
                  {filterType === "photo" && companyName === "tepco" && (
                    <TableCell align="center">
                      結果入力
                      <IconButton
                        className={classes.iconTooltip}
                        color="inherit"
                        aria-label="open drawer"
                        onClick={open ? handleDrawerClose : handleDrawerOpen}
                        disableRipple={true}
                        disableFocusRipple={true}
                      >
                        <HelpIcon fontSize="small" />
                      </IconButton>
                    </TableCell>
                  )}
                  {filterType === "photo" && companyName.includes("ntt") && (
                    <TableCell align="center">
                      {companyName === "ntt" ? "ME結果判定" : "判定結果"}
                    </TableCell>
                  )}
                  {filterType === "report" && (
                    <TableCell align="center">報告タグ</TableCell>
                  )}
                  <TableCell align="center">
                    {filterType === "photo" ? "撮影者" : "報告者"}
                  </TableCell>
                  <TableCell align="center">
                    {filterType === "photo" ? "撮影日時" : "報告日時"}
                  </TableCell>
                  <TableCell align="center">詳細</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {tableData.length > 0 &&
                  tableData.map((row, index) => (
                    <TableRow className={classes.tableRow} key={index}>
                      {activeDownload && (
                        <TableCell style={{ width: "2%" }} align="center">
                          <Checkbox
                            checked={downloadImage.includes(row.fileUrl)}
                            onChange={(e) => handleImageSelect(e, row.fileUrl)}
                            inputProps={{
                              "download-image": "primary checkbox",
                            }}
                            disabled={downloadImage.length >= 10}
                          />
                        </TableCell>
                      )}
                    <TableCell
                      component="th"
                      scope="row"
                      style={{ width: "10%" }}
                    >
                      <Link to={getViewUrlView(row.fileName)} target="_blank">
                        <div className={classes.thumbWrapper}>
                          {!(!pageTopLoader && loadedImages[row.fileUrl]) && (
                            <div className={classes.thumbSkeleton} />
                          )}
                            <img
                              key={`${row.fileUrl}-${loadCycle}`}
                              src={row.fileUrl}
                              height="90"
                              width="90"
                              loading="lazy"
                              ref={getImageRef(row.fileUrl)}
                              onLoad={() => handleImageLoad(row.fileUrl)}
                              onError={() => handleImageError(row.fileUrl)}
                            onMouseEnter={(e) =>
                              handleMouseEnter(row.fileUrl, e)
                            }
                            onMouseMove={handleMouseMove}
                            onMouseLeave={handleMouseLeave}
                            style={{
                              borderRadius: 6,
                              display: "block",
                              opacity: !pageTopLoader && loadedImages[row.fileUrl] ? 1 : 0,
                              transition: "opacity 0.35s ease-out",
                            }}
                          />
                        </div>
                      </Link>
                    </TableCell>
                    {companyName !== "mitsubishi" && (
                      <><TableCell style={{ width: columnWidth }} align="center">
                        {row.signNumber}
                      </TableCell>
                      <TableCell style={{ width: columnWidth }} align="center">
                        {row.signName}
                      </TableCell>
                      <TableCell style={{ width: columnWidth }} align="center">
                        {row.name}
                      </TableCell>
                      <TableCell style={{ width: columnWidth }} align="center">
                        {row.placeCode}
                      </TableCell>
                      </>
                    )}
                      {companyName === "mitsubishi" && (
                        <>
                          <TableCell style={{ width: "14%" }} align="center">
                            {row.venueName || row.name}
                          </TableCell>
                        </>
                      )}
                      {tagData !== null && tagData.length > 0 && companyName === "tepco" && (
                        <TableCell style={{ width: "30%" }} align="left">
                          <div className={classes.tagWrapper}>
                            {row.tag.length > 0 &&
                              row.tag.map((tag, index) => (
                                <Tooltip
                                  title={tagData[index]["tip"]}
                                  placement="top"
                                >
                                  <Chip
                                    key={index}
                                    style={{
                                      backgroundColor: "#ffed6f",
                                      color: "black",
                                    }}
                                    size="small"
                                    label={tag}
                                  ></Chip>
                                </Tooltip>
                              ))}
                          </div>
                        </TableCell>
                      )}
                      {companyName.includes("ntt") && (
                        <TableCell style={{ width: "20%" }} align="center">
                          {row.tag}
                        </TableCell>
                      )}
                      <TableCell style={{ width: "20%" }} align="center">
                        {row.user}
                      </TableCell>
                      <TableCell style={{ width: "20%" }} align="center">
                        {row.dateTime}
                      </TableCell>
                      <TableCell>
                        <Link to={getViewUrlView(row.fileName)} target="_blank">
                          <IconButton>
                            <OpenInNewIcon fontSize="small" />
                          </IconButton>
                        </Link>
                        <IconButton onClick={() => handleOpenMap(row.latitude, row.longitude)}>
                          <MapIcon fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                {tableData.length === 0 && (
                  <TableRow className={classes.tableRowNone}>
                    <TableCell colSpan={9} className={classes.noDataCell}>
                      データがありません
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
        {tableData.length > 0 && (
          <Grid item>
            <div className={classes.pagination}>
              <Pagination
                count={pageCount}
                page={currentPage}
                onChange={handlePageChange}
                color="secondary"
              />
            </div>
          </Grid>
        )}
      </Grid>
      {hoveredImage && (
        <div
          className={classes.imagePopup}
          style={{
            top: calculatePopupTop(hoverPosition.y),
            left: calculatePopupLeft(hoverPosition.x),
          }}
        >
          <img src={hoveredImage} alt="Preview" width={300} />
        </div>
      )}
      <Drawer anchor="right" open={mapDrawerOpen} onClose={handleCloseMap}>
        <Box
          style={{
            width: 480,
            height: '100vh', // 高さを画面にフィットさせる
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Box p={1}>
            <Typography variant="h6">電柱位置</Typography>
          </Box>
          <Box
            style={{
              flex: 1,
              overflowY: 'auto',
            }}
          >
            <iframe
              title="map"
              width="100%"
              height="100%"
              frameBorder="0"
              style={{ border: 0 }}
              loading="lazy"
              allowFullScreen
              src={`https://www.google.com/maps?q=${selectedLatLng.lat},${selectedLatLng.lng}&z=16&hl=ja&output=embed`}
            />
          </Box>
          <Box p={2} style={{ textAlign: 'center' }}>
            <Button
              href={`https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${selectedLatLng.lat},${selectedLatLng.lng}`}
              target="_blank"
              rel="noopener noreferrer"
              variant="outlined"
            >
              ストリートビューで開く
            </Button>
          </Box>
        </Box>
      </Drawer>
    </>
  );
};

PhotoTable.prototypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  dateRange: state.app.dateRange,
  periodType: state.app.periodType,
  homeImageData: state.home.homeImageData,
  homeImageDataNtt: state.home.homeImageDataNtt,
  homeImageDataHokuden: state.home.homeImageDataHokuden,
  homeMissionImageData: state.home.homeMissionImageData,
  totalAssetStats: state.home.totalAssetStats,
  filteredTotal: state.home.filteredTotal,
  selectedTag: state.app.selectedTag,
  tagSavingLoader: state.app.tagSavingLoader,
  filterType: state.app.filterType,
  reportData: state.report.reportData,
  currentPageNumber: state.home.currentPageNumber,
  reportDataNtt: state.report.reportDataNtt,
  selectedSeasonLabel: state.app.selectedSeasonLabel,
  selectedMissionLabel: state.app.selectedMissionLabel,
  pageTopLoader: state.app.pageTopLoader,
  missionOnly: state.app.missionOnly,
});

const mapDispatchToProps = (dispatch) => ({
  setPeriodType: (param) => dispatch(setPeriodType(param)),
  setCurrentPageNumber: (param) => dispatch(setCurrentPageNumber(param)),
  setSavedSelectedTagData: (param) => dispatch(setSavedSelectedTagData(param)),
  setSelectedTag: (param) => dispatch(setSelectedTag(param)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(null, { withTheme: true })(PhotoTable));
